import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { active: String }

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly activeValue: string

  toggle() {
    const className = this.activeValue || "expanded"
    this.element.classList.toggle(className)
    
    if (this.element.classList.contains(className)) {
      this.buttonTarget.textContent = "Hide Older Days"
    } else {
      this.buttonTarget.textContent = "Show Previous Days"
    }
  }
}
